import React, { useState } from 'react'
import { Grid, Popover, TableRow, TextField } from '@material-ui/core'
import TableCell from '@material-ui/core/TableCell'
import Paper from '@material-ui/core/Paper'
import Chip from '@material-ui/core/Chip'
import Button from '@material-ui/core/Button'
import { ContainerTitle } from '../../common/container-title'
import Modal from '../../../dsn-kernel/modal/Modal'
import { getVariableContextes, deleteVariableContexte } from '../../../store/actions/fonction/variable-contexte-action'
import { useDispatch, useSelector } from 'react-redux'
import { CreationVariableContexte } from './CreationVariableContexte'
import { Delete } from '@material-ui/icons'
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import { Types } from '../../../store/constants/fonction/fonction'
import { TableExtensions } from '../../../dsn-kernel/table/TableExtensions'
import { ImportExport } from '../components/ImportExport'
import { VARIABLE_CONTEXTE_ENDPOINT } from '../../../api/endpoints'

export const VariablesContexte = ({ classes }) => {
  const dispatch = useDispatch()
  const [filterBy, setFilterBy] = useState('')
  const variableContextes = useSelector(state => state.variableContexteModule.variableContextes)
  const referentiels = useSelector(state => state.referentiels.referentiels)
  const [anchorElPopover, setAnchorElPopover] = useState(null)
  const [selectedItem, setSelectedItem] = useState(false)
  const [showDeletingModal, setShowDeletingModal] = useState(false)
  const [itemToDelete, setItemToDelete] = useState(null)
  const createUpdateParameterPopover = (event, toEdit) => {
    if (toEdit && toEdit.reference) {
      toEdit.referenceObj = referentiels.find(ref => ref.nom === toEdit.reference)
    } else if (toEdit) {
      toEdit.referenceObj = null
    }
    setSelectedItem(toEdit)
    setAnchorElPopover(event.target)
  }
  const closePopover = () => {
    setAnchorElPopover(null)
  }
  const handleCancelDeleteClick = async (event, nom) => {
    setItemToDelete(null)
    setShowDeletingModal(false)
  }
  const handleValidateDeleteClick = async () => {
    dispatch(deleteVariableContexte(itemToDelete))
  }
  const handleDeleteClick = async (event, nom) => {
    setItemToDelete(nom)
    setShowDeletingModal(true)
  }

  return (
    <>
      <Grid container direction="row" justify="space-between" alignItems="flex-end">
        <Grid item style={{ margin: 10 }}>
          <TextField
            label={'Filtrer'}
            placeholder={'nom, description ou tags'}
            size="small"
            variant="outlined"
            onChange={event => setFilterBy(event.target.value)}
            margin="dense"
            type="search"
          />
        </Grid>
        <Grid style={{ marginBottom: 16 }}>
          <Button
            color="primary"
            variant="contained"
            size="small"
            className={classes.margin}
            onClick={createUpdateParameterPopover}
          >
            Ajouter
          </Button>
        </Grid>
      </Grid>
      <Paper>
        <TableExtensions
          search={filterBy}
          items={variableContextes}
          headCells={[
            {
              id: 'nom',
              label: 'Nom',
              filter: true,
            },
            {
              id: 'type',
              label: 'Type',
            },
            {
              id: 'description',
              label: 'Description',
              filter: true,
            },
            {
              id: 'tags',
              label: 'Tags',
              filter: true,
            },
            {
              id: 'fonction',
              label: 'Fonction',
            },
          ]}
          renderTableBody={list =>
            list.map((model, idx) => (
              <TableRow key={model.nom}>
                <TableCell>
                  <Link href="#" onClick={event => createUpdateParameterPopover(event, model)}>
                    {model.nom}
                  </Link>
                </TableCell>
                <TableCell>
                  {Types[model.type].label}
                  {Types[model.type] === Types.REFERENCE ? ` [${model.reference}]` : ''}
                </TableCell>
                <TableCell>{model.description}</TableCell>
                <TableCell>
                  {model.tags.map((tag, idx) => (
                    <Chip key={idx} label={tag} size="small" />
                  ))}
                </TableCell>
                <TableCell>{model.fonction ? model.fonction.nom : ''}</TableCell>
                <TableCell>
                  <IconButton
                    title="Supprimer"
                    aria-label="Supprimer"
                    size="small"
                    onClick={e => handleDeleteClick(e, model.nom)}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          }
        />
      </Paper>
      <ImportExport classes={classes} endpoint={VARIABLE_CONTEXTE_ENDPOINT} reloadData={getVariableContextes} />
      <Popover
        anchorEl={anchorElPopover}
        open={!!anchorElPopover}
        anchorPosition={{ top: 270, left: 660 }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >
        <Paper className={classes.popper} elevation={1}>
          <ContainerTitle classes={classes} title="Création de variable contexte" />
          <Grid container direction="row" justify="flex-end">
            <CreationVariableContexte classes={classes} toEdit={selectedItem} handleClose={closePopover} />
          </Grid>
        </Paper>
      </Popover>
      <Modal
        show={showDeletingModal}
        title="Suppression"
        body="Voulez-vous supprimer ce paramètre?"
        onHide={handleCancelDeleteClick}
        onValidate={handleValidateDeleteClick}
      />
    </>
  )
}
